import { Component } from '@angular/core';
import { NavController} from '@ionic/angular';
import { NewsDetailsModel } from '../../../providers/news/news';
import { EventProvider } from '../../../providers/event/event';
import { LoaderProvider } from '../../../providers/loader/loader';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

/**
 * Generated class for the NotificationDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-notification-details',
  templateUrl: 'notification-details.html',
  styleUrls:['./notification-details.scss']
})
export class NotificationDetailsPage {

  news: NewsDetailsModel;
  constructor(
  	public navCtrl: NavController,
    public router:Router,
    public eventService:EventProvider,
    private loadingCtrl:LoaderProvider,
    private translate:TranslateService,
  ) {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state || {};
    this.news = state['news'];
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter NotificationDetailsPage');
  }

  openEvent() {
    /*
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.eventService.getEventDetails(this.news.event.id).then((event) => {
      (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
    });

    */
  }

}
